var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photoModel"},[_c('div',{ref:"photoModel",staticClass:"photo",attrs:{"id":"photoModel"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }